import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import type { SbBlokData } from '@storyblok/react'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'

type ConnectPaymentBlockProps = SbBaseBlockProps<{
  body?: Array<SbBlokData>
}>

export function ConnectPaymentBlock({ blok }: ConnectPaymentBlockProps) {
  return (
    <div {...storyblokEditable(blok)}>
      {blok.body?.map((nestedBlock) => (
        <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} nested={true} />
      ))}
    </div>
  )
}
